export const LIBRARY_FILTER_SNAPSHOT_BUCKET_ALL = 'all';
export const LIBRARY_FILTER_SNAPSHOT_BUCKET_FREE = 'free';


export const normalizeLibraryAccessType = (rawAccessType) => (
  rawAccessType === LIBRARY_FILTER_SNAPSHOT_BUCKET_FREE
    ? LIBRARY_FILTER_SNAPSHOT_BUCKET_FREE
    : ''
);


export const getLibraryFilterSnapshotBucket = (rawAccessType) => (
  normalizeLibraryAccessType(rawAccessType) === LIBRARY_FILTER_SNAPSHOT_BUCKET_FREE
    ? LIBRARY_FILTER_SNAPSHOT_BUCKET_FREE
    : LIBRARY_FILTER_SNAPSHOT_BUCKET_ALL
);


export const buildNormalizedLibrarySearchParams = (searchParams) => {
  const normalizedSearchParams = new URLSearchParams(searchParams);
  const normalizedAccessType = normalizeLibraryAccessType(
    normalizedSearchParams.get('access_type') || ''
  );

  if (normalizedAccessType) {
    normalizedSearchParams.set('access_type', normalizedAccessType);
  } else {
    normalizedSearchParams.delete('access_type');
  }

  return normalizedSearchParams;
};
